import { useAuth } from "@/features/auth/hooks/useAuth";
import { Navigate } from "react-router-dom";

export const RequireAdmin = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 text-sm text-zinc-500">
        Loading…
      </div>
    );
  }

  if (!user || !user.roles?.includes("admin")) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};